import React from "react";
import Search from "semantic-ui-react/dist/es/modules/Search/Search";

const VmoSearch = (props) => {
  return <Search {...props} />;
};
export default VmoSearch;
